import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';
const OnshoreShipments = lazy(() => import('./onshores/OnshoreShipments'));
const OnshoreShipmentDetail = lazy(() => import('./shipment/Shipment'));
const ImportOnshoreShipments = lazy(() => import('./importOnshoreShipments/ImportOnshoreShipmentPage'));
import DiaryTaskForm from '../../diarytask/diarytask-form/DiaryTaskForm';

const OnshoreShipmentAppConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.externalAgent, // ['admin']
   routes: [
      {
         path: '/agent/onshoreShipments/onshoreShipment/:shipId',
         element: <OnshoreShipmentDetail />,
         children: [
            {
               path: 'diarytask/:taskId',
               element: <DiaryTaskForm />,
            },
         ],
      },
      {
         path: '/agent/onshoreShipments',
         element: <OnshoreShipments />,
      },

      {
         path: '/agent/onshoreShipments/importOnshoreShipment',
         element: <ImportOnshoreShipments />,
      },
   ],
};

export default OnshoreShipmentAppConfig;
